export default __webpack_public_path__ + "static/media/welcomeLandingbg-E-commerce.7a3af5e5.png";